/**
 * @desc 分页 树结构
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductCategroyTreeResponseDto>
>;
export function request(
  params: API.basics.productCategroy.pageTree.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productCategroy/page/tree`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
